import { Col, Container, Row } from "react-bootstrap";
import { EditorView } from "./components/editor/editor-view";
import { useState, useEffect } from "react";
import { DocumentContentService } from "../../services/document/document-content.service";
import { CreateNotification } from "../../components/notifier";

export const DocumentViewPage = (props: any) => {
  const { templateId, fileId } = props;
  const [contents, setContents] = useState<any>();

  const getData = async () => {
    DocumentContentService.getList(templateId, fileId)
      .then((res) => {
        setContents(res);
      })
      .catch((error) => {
        CreateNotification({
          title: "Thông báo",
          body: "Không đọc được thông tin tài liệu, vui lòng thử lại",
          icon: "/icons/error.png",
        });
        console.log(error);
      });
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [templateId, fileId]);

  return (
    <>
      <Container fluid>
        <Row>
          <Col sm={12} md={12} className="py-3">
            <EditorView content={contents} />
          </Col>
        </Row>
      </Container>
    </>
  );
};
